import React from 'react';
import styles from './Textarea.module.scss';
import { TextareaProps } from './Textarea.type';

const Textarea: React.FC<TextareaProps> = ({
  label = 'Label',
  onChangeText,
  isError = false,
  messageErr,
  required,
  ...rest
}) => {
  return (
    <div className={styles['Container']} data-testid="input-text-area">
      <span>{label}</span>
      <div
        className={`${styles['InputContainer']} ${
          styles[`${isError ? 'error' : ''}`]
        }`}
      >
        <textarea
          className="have-scroll"
          {...rest}
          required={required}
          onKeyUp={(e) => {
            if (onChangeText) {
              onChangeText(e.currentTarget.value);
            }
          }}
        />
      </div>
      {isError && <span>{messageErr}</span>}
    </div>
  );
};

export default Textarea;
